
import { Component, Prop, Vue } from 'vue-property-decorator';
import MediaImg from 'spa-ionata-admin/lib/components/MediaImg.vue';
import Business from '../models/Business';

@Component({ components: { MediaImg } })
export default class extends Vue {
  @Prop(Object) readonly business!: Business;
}
